import get from 'transmute/get';
export const getRejectedMessageId = get('rejectedMessageId');
export const getRejectionReason = get('rejectionReason');
export const getRejectionDetails = get('rejectionDetails');